import { useMutation } from '@tanstack/react-query';
import { EFromPageTransfer } from 'v2/interfaces/financial';
import type { ISendTransfer } from 'v2/interfaces/financial';
import financialService from 'v2/services/financial';

export const useBankTransfer = () => {
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: async (data: ISendTransfer) => {
      await financialService
        .sendTransfer({
          ...data,
          from: EFromPageTransfer.OLD_CARD
        })
        .toPromise();
    }
  });

  return {
    bankTransfer: (data: ISendTransfer) => mutateAsync(data),
    isPending,
    error
  };
};
